
import { getToken } from "firebase/messaging";

import { getFirebaseMessaging } from "./FireBase";
import { saveFcmToken, saveFcmTokenRole } from "../CommonUrl";
import { postClientUrlWithToken } from "../Utils/restUtils";
import { setFcmToken } from "../Redux/Reducer";
import { FIREBASE_VAPID_KEY } from "../Constant";


export const sendFcmToken = async (data,dispatch) => {


  try {
    const permission = await Notification.requestPermission();
    const messaging = await getFirebaseMessaging();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:FIREBASE_VAPID_KEY,
      });
      dispatch(setFcmToken(token))
      const postData = {
        user_id: data?.company_user_id,
        device_token: token,
        company_id: data?.active_company

      }
      const responce = await postClientUrlWithToken(data?.url, data?.client_role_id===1?saveFcmToken:saveFcmTokenRole, postData)


    }
  } catch (err) {
    console.error("An error occurred while retrieving token. ", err);
  }
};

